import React, { useEffect } from "react";
import Hero from "./components/Hero";
import Welcome from "./components/Welcome";
import Why from "./components/Why";
import Vision from "./components/Vision";
import Doctors from "./components/Doctors";

export default function HomeScreen({ id }) {
  useEffect(() => {
    window.scrollTo(0, 0); // Ensures the page scrolls to the top on mount
  }, []);
  return (
    <div className="">
      <Hero />
      <Welcome id={id === "about" ? "about" : ""} />
      <Why />
      <Vision />
      <Doctors />
    </div>
  );
}
